import {BaseSpringServiceCB} from '@aiknow-srl/aik-angular-sdk';
import {UserOPEEnum} from "./UserOPEEnum";


/**
 * O inner class
 */

class O {
  public binary!: string;
  public mimeType!: string;
  public filename!: string;
}

/**
 * I inner class
 */
class I {

}


/**
 * put reseller class
 */

export class ExportAllCustomersDevicesCB extends BaseSpringServiceCB {

  /**
   * I
   */
  public i: I;


  /**
   * O
   */
  public o: O;


  /**
   * constructor
   */
  constructor(){
    super(UserOPEEnum.ExportAllCustomersDevices);
    this.i = new I();
    this.o = new O();
  }

}
